import { Form } from 'react-bootstrap'

export { Col, Row } from 'react-bootstrap'

export const FormRow = Form.Row
